<template>
  <div class="container">
    <div class="content_top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news/list' }">新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_wrapper">
      <div class="top_wraper">
        <div class="title">{{ newsDeatil.name }}</div>
        <div>
          浏览次数：{{ newsDeatil.views }} 发布时间：{{ newsDeatil.createTime }}
        </div>
      </div>
      <div></div>
      <div class="content">
        <div class="context" v-html="newsDeatil.context"></div>
      </div>
    </div>
  </div>
</div></template>

<script>
import requests from "@/api/request";

export default {
  name: "newsDetailView",
  data() {
    return {
      newsDeatil: {}
    };
  },
  mounted() {
    this.getNewsDeatil(this.$route.query.newsId);
  },
  methods: {
    async getNewsDeatil(newsId) {
      return requests({
        url: "/news/showNewsInfo?newsId=" + newsId,
        method: "GET"
      }).then(res => {
        console.log('getNewsDeatil', res);
        this.$set(this, 'newsDeatil', res.data);
        // console.log('getActivityDeatil', this.activityDeatil);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    }

  }
};
</script>
<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  margin: 20px 0;
}

.main_wrapper {
  border: 1px solid #ccc;
  border-radius: 3px;
  /* margin-bottom: 20px; */
}

.top_wraper {
  padding: 20px 0;
  border-bottom: 1px solid #ccc;
}

.title {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: left;
  padding: 50px;
}

.top {
  line-height: 30px;
  font-size: 16px;
  font-weight: 600;
}

.context {
  margin-top: 20px;
  font-size: 16px;
  line-height: 28px;
  color: #333333;
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner:hover {
  color: #63065f;
}
</style>
